var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperaMiniSeeklogocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 506.37 506.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 275.74,
    y1: 35.64,
    x2: 275.74,
    y2: 538.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e52d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#981917"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 359.17,
    y1: 500.35,
    x2: 359.17,
    y2: 66.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e94d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#941914"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.29,81.94A251.92,251.92,0,0,0,275.74,30.06c-139.82,0-253.18,113.36-253.18,253.18S135.92,536.43,275.74,536.43A253.18,253.18,0,0,0,429.29,81.94ZM196.4,421.35c-29-37.53-46.38-85.64-46.38-138.11,0-48,14.57-92.35,39.24-128.27a2.37,2.37,0,0,1,.15-.21c22.88-30.51,53.84-49.23,87.94-49.23,70.39,0,127.46,79.79,127.46,178.21s-57.07,178.2-127.46,178.2c-30.68,0-58.8-15.14-80.8-40.4A.5.5,0,0,1,196.4,421.35Z",
    transform: "translate(-22.56 -30.06)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.93,283.24a252.73,252.73,0,0,1-99.64,201.3,190.88,190.88,0,0,1-76.19,15.81c-63,0-119.3-30.67-156.55-78.81,22,25.26,50.12,40.4,80.8,40.4,70.39,0,127.46-79.79,127.46-178.2S347.74,105.53,277.35,105.53c-34.1,0-65.06,18.72-87.94,49.23C226.34,101,285.92,66.13,353.1,66.13a191.05,191.05,0,0,1,76.19,15.81A252.75,252.75,0,0,1,528.93,283.24Z",
    transform: "translate(-22.56 -30.06)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperaMiniSeeklogocom);
export default __webpack_public_path__ + "static/media/opera-mini-seeklogo.com.48524370f2d1518816ce51dc303831a5.svg";
export { ForwardRef as ReactComponent };